import { render, staticRenderFns } from "./update-storage.vue?vue&type=template&id=115df258"
import script from "./update-storage.vue?vue&type=script&lang=js"
export * from "./update-storage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports